/* Reels Carousel - Simple */
(function() {
  function init(el) {
    if (!el || el.classList.contains('ready')) return;
    
    var swiperEl = el.querySelector('.swiper');
    if (!swiperEl) return;

    // Verificar que Swiper esté disponible
    if (typeof Swiper === 'undefined') {
      setTimeout(function() { init(el); }, 100);
      return;
    }

    var cols = { 
      desktop: parseFloat(el.dataset.colsDesktop) || 3, 
      mobile: parseFloat(el.dataset.colsMobile) || 1.2 
    };
    var gap = parseInt(el.dataset.gap) || 16;
    var muted = false; // Audio activo por defecto
    
    // Con centeredSlides: true, el slide activo siempre estará en el centro
    // Columnas impares (3, 5, 7) aseguran que haya un centro claro:
    // - 3 columnas: activo en posición #2 (centro)
    // - 5 columnas: activo en posición #3 (centro)
    // - 7 columnas: activo en posición #4 (centro)

    function stopAll() {
      el.querySelectorAll('.reels__slide').forEach(function(s) {
        var v = s.querySelector('.reels__video');
        if (v) { 
          v.pause();
          
          // Remover handler de preview si existe
          if (v._previewHandler) {
            v.removeEventListener('timeupdate', v._previewHandler);
            v._previewHandler = null;
          }
        }
        // Resetear estados
        s.removeAttribute('data-playing');
        s.removeAttribute('data-previewing');
      });
    }

    function preview(slide) {
      if (!slide) return;
      
      // Verificar que este slide sigue siendo el activo
      if (!slide.classList.contains('swiper-slide-active')) return;
      
      var v = slide.querySelector('.reels__video');
      if (!v) return;
      
      // Auto-reproducción en bucle de los primeros 3 segundos en muted
      v.muted = true;
      v.currentTime = 0;
      
      // Remover event listener anterior si existe
      if (v._previewHandler) {
        v.removeEventListener('timeupdate', v._previewHandler);
      }
      
      // Crear handler para el loop de preview
      v._previewHandler = function() {
        // Solo hacer loop si está en modo preview y sigue siendo el slide activo
        if (slide.classList.contains('swiper-slide-active') && 
            slide.getAttribute('data-playing') !== 'true' && 
            v.currentTime >= 3) {
          v.currentTime = 0;
        }
      };
      
      v.addEventListener('timeupdate', v._previewHandler);
      
      // Reproducir y marcar como previewing solo cuando empiece a reproducirse
      var playPromise = v.play();
      if (playPromise !== undefined) {
        playPromise.then(function() {
          // Solo marcar si sigue siendo el slide activo
          if (slide.classList.contains('swiper-slide-active')) {
            slide.setAttribute('data-previewing', 'true');
          }
        }).catch(function() {
          // Si falla la reproducción automática, mantener el poster visible
        });
      }
    }

    function syncSound() {
      el.querySelectorAll('.reels__sound').forEach(function(b) { b.dataset.muted = muted ? 'true' : 'false'; });
      el.querySelectorAll('.reels__video').forEach(function(v) { v.muted = muted; });
    }

    // Configuración con slide activo centrado
    var swiper = new Swiper(swiperEl, {
      slidesPerView: cols.mobile,
      spaceBetween: gap,
      centeredSlides: true,
      loop: true,
      grabCursor: true,
      speed: 400,
      
      navigation: {
        prevEl: '.reels__arrow--prev',
        nextEl: '.reels__arrow--next',
      },
      
      pagination: {
        el: el.querySelector('.reels__dots'),
        clickable: true,
      },
      
      breakpoints: {
        750: {
          slidesPerView: cols.mobile * 1.5,
          spaceBetween: gap,
          centeredSlides: true
        },
        990: {
          slidesPerView: cols.desktop,
          spaceBetween: gap,
          centeredSlides: true
        }
      },
      
      on: {
        init: function(swiper) {
          el.classList.add('ready');
          swiperEl.swiperInstance = swiper;
          syncSound(); // Sincronizar estado de audio inicial
          
          setTimeout(function() {
            var activeSlide = swiperEl.querySelector('.swiper-slide-active');
            if (activeSlide) preview(activeSlide);
          }, 100);
        },
        slideChange: function() {
          stopAll();
        },
        slideChangeTransitionEnd: function() {
          var activeSlide = swiperEl.querySelector('.swiper-slide-active');
          if (activeSlide) preview(activeSlide);
        }
      }
    });

    swiperEl.addEventListener('click', function(e) {
      // Permitir que las flechas de navegación funcionen
      if (e.target.closest('.reels__arrow--prev') || e.target.closest('.reels__arrow--next')) {
        return; // No hacer nada, dejar que Swiper maneje la navegación
      }

      var slide = e.target.closest('.reels__slide');
      if (!slide) return;
      var v = slide.querySelector('.reels__video');

      // Permitir interacción con el product card (links y botones)
      if (e.target.closest('.product-card-new--reel-mode')) {
        // Si es el link del título o imagen, permitir navegación
        if (e.target.closest('.product-card-new__title-link') || e.target.closest('.product-card-new__gallery-link')) {
          e.stopPropagation();
          return;
        }
        // Si es el botón de agregar, permitir que product-form lo maneje
        if (e.target.closest('.product-card-new__add-button')) {
          e.stopPropagation();
          return;
        }
      }
      
      // Botón de sonido
      if (e.target.closest('.reels__sound')) {
        e.stopPropagation();
        muted = !muted;
        syncSound();
        return;
      }
      
      // Botón de play
      if (e.target.closest('.reels__play')) {
        e.stopPropagation();
        if (v) {
          // Remover el handler de preview loop
          if (slide.getAttribute('data-previewing') === 'true') {
            slide.removeAttribute('data-previewing');
            if (v._previewHandler) {
              v.removeEventListener('timeupdate', v._previewHandler);
              v._previewHandler = null;
            }
            v.currentTime = 0; // Solo reiniciar si viene del preview
          }
          
          v.muted = muted;
          var playPromise = v.play();
          if (playPromise !== undefined) {
            playPromise.then(function() {
              slide.setAttribute('data-playing', 'true');
            }).catch(function() {
              // Error al reproducir
            });
          } else {
            slide.setAttribute('data-playing', 'true');
          }
        }
        return;
      }
      
      // Botón de pausa
      if (e.target.closest('.reels__pause')) {
        e.stopPropagation();
        if (v) { 
          v.pause(); 
          slide.removeAttribute('data-playing');
        }
        return;
      }
      
      // Click en slide inactivo para navegar
      if (!slide.classList.contains('swiper-slide-active')) {
        // Obtener el índice real del slide (no el clonado)
        var allSlides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
        var realIndex = allSlides.indexOf(slide);
        
        // Si el slide tiene data-swiper-slide-index, usarlo (es un slide clonado)
        if (slide.dataset.swiperSlideIndex !== undefined) {
          realIndex = parseInt(slide.dataset.swiperSlideIndex);
        }
        
        if (!isNaN(realIndex) && realIndex >= 0) {
          swiper.slideToLoop(realIndex, 600);
        }
      }
    });
  }

  // Almacenar instancias de Swiper para poder destruirlas
  var swiperInstances = {};

  function run() { 
    document.querySelectorAll('.reels[data-cols-desktop]').forEach(function(el) {
      var id = el.id;
      var swiperEl = el.querySelector('.swiper');
      
      // Si ya existe una instancia, destruirla primero
      if (id && swiperInstances[id]) {
        swiperInstances[id].destroy(true, true);
        delete swiperInstances[id];
      } else if (swiperEl && swiperEl.swiperInstance) {
        swiperEl.swiperInstance.destroy(true, true);
      }
      
      init(el);
      
      // Guardar la instancia si tiene un ID
      if (id && swiperEl && swiperEl.swiperInstance) {
        swiperInstances[id] = swiperEl.swiperInstance;
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    // Esperar a que Swiper esté cargado
    if (typeof Swiper === 'undefined') {
      var checkSwiper = setInterval(function() {
        if (typeof Swiper !== 'undefined') {
          clearInterval(checkSwiper);
          run();
        }
      }, 50);
    } else {
      run();
    }
  }

  document.addEventListener('shopify:section:load', function(e) {
    try {
      var s = e.target.querySelector('.reels[data-cols-desktop]');
      if (s) { 
        var id = s.id;
        var swiperEl = s.querySelector('.swiper');
        
        // Destruir instancia anterior si existe
        if (id && swiperInstances[id]) {
          swiperInstances[id].destroy(true, true);
          delete swiperInstances[id];
        } else if (swiperEl && swiperEl.swiperInstance) {
          swiperEl.swiperInstance.destroy(true, true);
        }
        
        s.classList.remove('ready'); 
        
        setTimeout(function() {
          init(s);
          if (id && swiperEl && swiperEl.swiperInstance) {
            swiperInstances[id] = swiperEl.swiperInstance;
          }
        }, 50);
      }
    } catch (err) {
      console.error('Error in reels section:load', err);
    }
  });

  document.addEventListener('shopify:section:unload', function(e) {
    try {
      var s = e.target.querySelector('.reels[data-cols-desktop]');
      if (s && s.id && swiperInstances[s.id]) {
        swiperInstances[s.id].destroy(true, true);
        delete swiperInstances[s.id];
      }
    } catch (err) {
      console.error('Error in reels section:unload', err);
    }
  });
})();
